// Display adapter for the server's validated choice contract, including old drafts.
const isDisplayRule = (rule) => rule && typeof rule.explanation === 'string'
  && ['AND', 'OR'].includes(rule.condition_logic) && Array.isArray(rule.conditions) && rule.conditions.length > 0
  && rule.conditions.every((item) => item && typeof item.tag === 'string'
    && typeof item.condition === 'string' && typeof item.value === 'string');

export const decisionPlanTargets = (step) => step?.paths?.length
  ? Object.fromEntries(step.paths.map((path) => [path.key, path.flow_key]))
  : step?.branches || {};

export const continuesAfterSuccess = (raw) => {
  try {
    const data = typeof raw === 'string' ? JSON.parse(raw) : raw || {};
    const hasTarget = Object.prototype.hasOwnProperty.call(data, 'targetFlowId')
      || Object.prototype.hasOwnProperty.call(data, 'target_flow_id');
    const target = Object.prototype.hasOwnProperty.call(data, 'targetFlowId')
      ? data.targetFlowId : data.target_flow_id;
    return data.decisionMode === 'execution' && hasTarget && [null, ''].includes(target);
  } catch {
    return false;
  }
};

export const decisionPaths = (data = {}) => {
  try {
    if (data.decisionMode === 'execution') {
      if (typeof data.yesLabel !== 'string' || typeof data.noLabel !== 'string') return [];
      return [{ key: 'yes', label: data.yesLabel, rule: null, outcome: 'success', targetFlowId: data.targetFlowId ?? data.target_flow_id ?? null },
        { key: 'no', label: data.noLabel, rule: null, outcome: 'failure', targetFlowId: data.rejectFlowId ?? data.reject_flow_id ?? null }];
    }
    if (data.routes_json) {
      const parsed = JSON.parse(data.routes_json);
      if (!Array.isArray(parsed?.cases) || !parsed.otherwise) return [];
      const paths = [...parsed.cases, { ...parsed.otherwise, rule: null }];
      if (!paths.every((path, index) => path && typeof path.key === 'string' && typeof path.label === 'string'
        && (index === paths.length - 1 || isDisplayRule(path.rule)))) return [];
      return paths.map((path) => ({ ...path, targetFlowId: data.routeFlowIds?.[path.key] ?? null }));
    }
    const rule = JSON.parse(data.rule_json || 'null');
    if (!isDisplayRule(rule) || typeof data.yesLabel !== 'string' || typeof data.noLabel !== 'string') return [];
    return [{ key: 'yes', label: data.yesLabel, rule, targetFlowId: data.targetFlowId ?? data.target_flow_id ?? null },
      { key: 'no', label: data.noLabel, rule: null, targetFlowId: data.rejectFlowId ?? data.reject_flow_id ?? null }];
  } catch {
    // Incomplete saved choices remain editable through the same assistant.
    return [];
  }
};

export const decisionPlanPaths = (step) => {
  const targets = decisionPlanTargets(step);
  return decisionPaths(step?.data).map((path) => ({ ...path, flowKey: targets[path.key] || '' }));
};
